import { twMerge } from "tailwind-merge";
import { SupportCategoryTree } from "../SupportCategoryTree/SupportCategoryTree";
import { SupportSidebarSearchButton } from "./SupportSidebarSearchButton";
import { SupportSidebarSupportButton } from "./SupportSidebarSupportButton";
import { Category, Article } from "../../support.types";

export type Props = {
  articles: Article[];
  categories: Category[];
  onNavigationClick?: (article: Article) => void;
  onSupportClick: () => void;
  onSearchClick: () => void;
};

export function SupportSidebar({
  articles,
  categories,
  onSearchClick,
  onSupportClick,
  onNavigationClick,
}: Props) {
  return (
    <aside
      className={twMerge(
        "hidden md:block md:relative md:translate-x-0 md:border-l md:w-64 md:h-auto"
      )}
    >
      <div className="flex flex-col gap-6 h-full overflow-y-auto p-4 md:py-12">
        <div className="flex flex-col gap-3">
          <SupportSidebarSearchButton onClick={onSearchClick} />
          <SupportSidebarSupportButton onClick={onSupportClick} />
        </div>
        {articles.length > 0 && (
          <SupportCategoryTree
            categories={categories}
            onArticleClick={onNavigationClick}
          />
        )}
      </div>
    </aside>
  );
}

export default SupportSidebar;
